import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "expand_more" }, [
      _createElementVNode("g", null, [
        _createElementVNode("path", {
          id: "expand_more_2",
          d: "M12 16L6 9.51351L7.4 8L12 12.973L16.6 8L18 9.51351L12 16Z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }